// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/library-big.js';

import { paths } from '../generated/library-big';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('library-big', Original, paths);
